const environment = {
  client_id: '634133218557-dipq0q0noilkf2jgarp0g2jssoduje3c.apps.googleusercontent.com',
  discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
  scope: 'https://www.googleapis.com/auth/spreadsheets',
};

export default environment;
